import cx from 'classnames'
import { ChevronDown } from 'tabler-icons-react';
import styles from 'partials/story-box-title.module.scss'

export const StoryAccordionTitle = ({
	title,
	isOpen,
	hasExpand,
	icon,
	onOpen,
	className
}) => {
	const headerClass = cx(styles.header, className);

	const expandClass = cx(styles.expnad, {
		[styles.openBox]: isOpen
	});

	const titleClass = cx(styles.title, {
		[styles.hasExpnad]: !hasExpand
	});

	const Icon = icon;
	const titleIcon = <Icon size={22} />;

	return (
		<header
			className={headerClass}
			onClick={onOpen}
			onKeyPress={onOpen}
			role="button"
			tabIndex="0">
			<h3 className={titleClass}>
				<span className={styles.titleIcon}>{titleIcon}</span>
				<span>{title}</span>
			</h3>
			{hasExpand && <ChevronDown size={16} className={expandClass} />}
		</header>
	);
};
